import { ApiProperty } from "@nestjs/swagger";



export class LocationDto {
    @ApiProperty()
    id: number;

    @ApiProperty()
    locationName: string;

    @ApiProperty()
    address: string;

    @ApiProperty()
    unitNo: string;

    @ApiProperty()
    division: string;
    @ApiProperty()
    state: string;

    @ApiProperty()
    gpsLocation: string;

    @ApiProperty()
    plantId: number;

    @ApiProperty()
    isActive: boolean;
    
    @ApiProperty()
    createdUser: string | null;

    @ApiProperty()
    createdAt: Date;

    @ApiProperty()
    updatedUser: string | null;

    @ApiProperty()
    updatedAt: Date;

    @ApiProperty()
    versionFlag: number;
}